<template>
  <div class="withdraw-list-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose" :close-on-click-modal="false" class="el-dialogs">
      <!--操作栏-->
      <div class="action-bar">
        <el-input size="small" clearable placeholder="流水id" v-model="params.id" @keyup.native.enter="getWithdrawList('status')" class="param-input" />
         <el-input size="small" clearable placeholder="用户id" v-model.number="params.uid" @keyup.native.enter="getWithdrawList('status')" class="param-input" />
         提现类型:
         <el-select v-model.number="params.withdrawType" clearable size="small" placeholder="请选择提现类型" @change="getWithdrawList('status')">
           <el-option v-for="item in withdrawList" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
          订单状态:
         <el-select v-model.number="params.status" clearable size="small" placeholder="请选择订单状态" @change="getWithdrawList('status')">
           <el-option v-for="item in statusList" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
          提现方式:
         <el-select v-model="params.payType" clearable size="small" placeholder="请选择提现方式" @change="getWithdrawList('status')">
           <el-option v-for="item in payList" :value="item.value" :label="item.label" :key="item.value"></el-option>
        </el-select>
        <el-date-picker v-model="params.time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="changeTime"></el-date-picker>
        <el-button type="primary" size="small" @click="getWithdrawList('status')">搜索</el-button>
      </div>
      <div class="price-box">总提现金额: {{witdordMoney | numFormat}}元</div>
      <!--数据表格-->
      <el-table :data="tableData" border style="width: 100%" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">

        <el-table-column prop="id" label="流水id" align="center" min-width="220" fixed>
          <template slot-scope="scope">
            <span>{{scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="districtCode" label="商区码" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{scope.row.districtCode }}</span>
          </template>
        </el-table-column>        
           <el-table-column prop="promSeqe" label="推广序列" align="center" min-width="80">
          <template slot-scope="scope">
            <span>{{scope.row.promSeqe }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="linkRemark" label="链接备注" align="center" min-width="80">
          <template slot-scope="scope">
            <span>{{scope.row.linkRemark }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="用户名称" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="uid" label="用户id" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{scope.row.uid }}</span>
          </template>
        </el-table-column>        
        <el-table-column prop="amount" label="金币" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{(scope.row.amount || '0') | numFormat}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="oid" label="第三方平台id" align="center" min-width="220">
          <template slot-scope="scope">
            <span>{{scope.row.oid }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="money" label="提现金额" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{(scope.row.money/100 || '0') | numFormat}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payMoney" label="实际到账金额" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{(scope.row.payMoney || '0') | numFormat}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payType" label="提现方式" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{scope.row.payType | payRule}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="withdrawType" label="提现类型" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{scope.row.withdrawType | withdrawRule}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="actName" label="交易账户持有人" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{scope.row.actName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="act" label="交易账户" align="center" min-width="200">
          <template slot-scope="scope">
            <span>{{scope.row.act}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="userIP" label="用户IP" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.userIP }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deviceType" label="设备系统类型" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.deviceType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="devID" label="设备id" align="center" min-width="220">
          <template slot-scope="scope">
            <span>{{scope.row.devID }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{scope.row.status | statusRule}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusDesc" label="状态描述" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{scope.row.statusDesc || '无'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" align="center" min-width="200">
          <template slot-scope="scope">
            <span>{{scope.row.createdAt | changeDate}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updatedAt" label="更新时间" align="center" min-width="200">
          <template slot-scope="scope">
            <span>{{scope.row.updatedAt | changeDate}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" align="center" fixed="right" width="130">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="editDesc(scope.row)"></el-button>
        </template>
      </el-table-column> -->
      </el-table>
      <el-pagination :page-sizes="[5]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 5" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
      <div class="zw"></div>
    </el-dialog>
  </div>
</template>
<script>
import { changeTime } from '@/utils/global'
import API from '@/api'
export default {
  data() {
    return {
      dialogVisible: false,
      title: '提现记录查看',
      tableData: [],
      time: '',
      loading: false,
      witdordMoney: 0,
      total: 0,
      // 提现类型选择
      withdrawList:[
        {
          label: '代理提现',
          value: 0
        },
        {
          label: '金币提现',
          value: 1
        },
        {
          label: '商区提现',
          value: 2
        }
      ],
      // 订单状态选择
      statusList:[
        {
          label: '未审核',
          value: 1
        },
        {
          label: '审核通过，转账中',
          value: 2
        },
        {
          label: '已拒绝',
          value: 3
        },
        {
          label: '未知错误',
          value: 4
        },
        {
          label: '提现成功',
          value: 5
        },
        {
          label: '提现失败',
          value: 6
        },
      ],
      // 提现方式选择
      payList:[
        {
          label: '支付宝',
          value: 'alipay'
        },
        {
          label: '银行卡',
          value: 'bankcard'
        },
      ],
      // 请求订单列表参数
      params: {
        discCode:'',
        pageNumber: 1,
        pageSize: 5,
        time:'',
        id: '',
        uid: '',
        withdrawType: '',
        status: 5,
        payType: '',
        startTime: '',
        endTime: '',
        agent: '',
        // sortKey: '',
        // sortValue: '',
      }
    }
  },
  filters: {
    statusRule(val) {
      const statusList = {
        1: '未审核',
        2: '审核通过',
        3: '已拒绝',
        4: '未知错误',
        5: '提现成功',
        6: '提现失败'
      }
      return statusList[val] ? statusList[val] : '未知'
    },
    payRule(val) {
      const payList = {
        alipay: '支付宝',
        bankcard: '银行卡',
      }
      return payList[val] ? payList[val] : '未知'
    },
    withdrawRule(val) {
      const withdrawList = {
        0: '代理提现',
        1: '金币提现',
        2: '商区提现'
      }
      return withdrawList[val] ? withdrawList[val] : '未知'
    },
  },
  methods: {
    // 请求提现记录列表
    getWithdrawList(type) {
      if (type === 'status') {
        this.params.pageNumber = 1
      }
      this.loading = true
      API.getWithdrawLists(this.params).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
          this.witdordMoney = res.data.witdordMoney
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getWithdrawList()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getWithdrawList()
    },
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || ''
        this.params.endTime = changeTime(time[1]) || ''
      } else {
        this.params.startTime = ''
        this.params.endTime = ''
      }
      this.getWithdrawList('status')
    },
    // 打开弹窗
    open(row) {
      this.dialogVisible = true;
      this.params.agent = row.agent;
       this.params.discCode = row.districtCode
      this.getWithdrawList();
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params= {
        pageNumber: 1,
        pageSize: 5,
        id: '',
        uid: '',
        time:'',
        withdrawType: '',
        status: 5,
        payType: '',
        startTime: '',
        endTime: '',
        agent: '',
      }
    }
  }
}
</script>
<style lang="scss">
.withdraw-list-box {
  .icon {
    font-size: 16px;
    margin-left: 10px;
    cursor: pointer;
    color: #e63765;
    vertical-align: middle !important;
    &:hover {
      color: #eb5f84;
    }
  }
  .zw {
    height: 100px;
  }
  .price-box {
    font-size: 16px;
  }
}
</style>

